// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Import components
import ImageLoader from '../ImageLoader';

// Import Utils
import { getClassNames } from '../../../utils';

const ConcertCard = ({
  title,
  performancesViewTeaser,
  sellingStatus,
  sellingStatusColour,
  image,
  showBookingLink,
  url,
  dark,
  loaded,
  handlePerformancesModal,
  inWishlist,
  toggleWishlist,
  ...props
}) => (
  <div className="c-card-listing__section js-card">
    <div className="c-card-listing__inner">
      <div className={getClassNames(props, 'c-card  c-card--regular', {
        'c-card--dark': dark,
        'is-loaded': loaded,
      })}
      >
        <a className="c-card__link  g-split-image" href={url}>
          {image && (
            <div className="c-card__inner">
              <ImageLoader image={image} alt={title} />
            </div>
          )}
          <div className="c-card__content">
            {sellingStatus && (
              <strong
                className="c-hero-stack__ribbon c-hero-stack__ribbon--selling"
                style={{
                  ...(sellingStatusColour && {
                    borderColor: sellingStatusColour,
                    color: sellingStatusColour,
                  }),
                }}
              >
                {sellingStatus}
              </strong>
            )}

            {title && <h4 className="c-card__title"><span>{title}</span></h4>}
            {performancesViewTeaser && <p className="c-card__meta">{performancesViewTeaser}</p>}
          </div>
        </a>

        <div className="c-card__icons">
          {
            showBookingLink
            && (
              <button type="button" className="c-card__icon" onClick={handlePerformancesModal}>
                <span>
                  <svg><use xlinkHref="#ticket" /></svg>
                  <span className="u-visually-hidden">Book now</span>
                </span>
              </button>
            )
          }

          <button type="button" className="c-card__icon" onClick={toggleWishlist}>
            <span>
              {inWishlist ? (
                <svg>
                  <use xlinkHref="#wishlist-full" />
                </svg>
              ) : (
                <svg>
                  <use xlinkHref="#wishlist-empty" />
                </svg>
              )}
              <span className="u-visually-hidden">Add to wishlist</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
);

ConcertCard.propTypes = {
  inWishlist: PropTypes.bool,
  toggleWishlist: PropTypes.func.isRequired,
  image: PropTypes.string,
  performancesViewTeaser: PropTypes.string.isRequired,
  sellingStatus: PropTypes.string,
  sellingStatusColour: PropTypes.string,
  title: PropTypes.string.isRequired,
  showBookingLink: PropTypes.bool,
  url: PropTypes.string,
  dark: PropTypes.bool,
  loaded: PropTypes.bool,
  handlePerformancesModal: PropTypes.func,
};

ConcertCard.defaultProps = {
  inWishlist: false,
  showBookingLink: false,
  dark: false,
  loaded: false,
  url: null,
  handlePerformancesModal: null,
  image: null,
  sellingStatus: null,
  sellingStatusColour: null,
};

export default ConcertCard;
